require('../modules/es6.object.to-string');
require('../modules/web.dom.iterable');
require('../modules/es6.weak-map');
module.exports = require('../modules/$.core').WeakMap;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/weak-map.js
// module id = 1030
// module chunks = 2